import { render, staticRenderFns } from "./OrganizationSwitcher.vue?vue&type=template&id=18d7e0d2&scoped=true"
import script from "./OrganizationSwitcher.vue?vue&type=script&lang=ts"
export * from "./OrganizationSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./OrganizationSwitcher.vue?vue&type=style&index=0&id=18d7e0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d7e0d2",
  null
  
)

export default component.exports